import NativeObjectViewerComponent from './containers/NativeObjectViewer';

export default [
  {
    component: NativeObjectViewerComponent,
    mode: 'wrap',
    name: 'NativeObjectViewer',
    target: 'TextViewer',
  },
];

export { NativeObjectViewerComponent };
